import React, { forwardRef, memo } from "react";
import { getCellDisplay } from "./shiftUtils";

const RosterCell = forwardRef(function RosterCell(
  {
    userId,
    dateStr,
    dayData,
    draftCell,
    shiftTemplates,
    isSelected,
    isFocused,
    isDraftMode,
    isWeekend,
    isToday,
    onMouseDown,
    onMouseEnter,
    onClick,
    onKeyDown,
  },
  ref,
) {
  let display;
  if (draftCell?.type === "shift" && draftCell.shift) {
    const shiftIdx = shiftTemplates.indexOf(draftCell.shift);
    const colorIndex = (shiftIdx >= 0 ? shiftIdx : shiftTemplates.findIndex((s) => s.id === draftCell.shiftId)) % 6;
    display = {
      code: draftCell.shift.name.trim().split(/\s+/).pop()[0].toUpperCase(),
      colorIndex,
      cls: `roster-cell--shift range-color-${colorIndex} is-draft`,
      shift: draftCell.shift,
    };
  } else if (draftCell?.type === "off" || draftCell?.type === "leave") {
    display = { code: "L", colorIndex: -1, cls: "roster-cell--leave is-draft", shift: null };
  } else {
    display = getCellDisplay(dayData, shiftTemplates);
  }

  const classes = [
    "roster-day-cell",
    display.cls,
    isSelected ? "is-selected" : "",
    isFocused ? "is-focused" : "",
    isWeekend ? "is-weekend" : "",
    isToday ? "is-today" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <td
      ref={ref}
      role="gridcell"
      tabIndex={isFocused ? 0 : -1}
      className={classes}
      title={display.tooltip || display.shift?.name || undefined}
      onMouseDown={(e) => onMouseDown(e, userId, dateStr)}
      onMouseEnter={() => onMouseEnter(userId, dateStr)}
      onClick={(e) => onClick(e, userId, dateStr)}
      onKeyDown={(e) => onKeyDown(e, userId, dateStr)}
      aria-selected={isSelected}
    >
      {display.code}
    </td>
  );
});

export default memo(RosterCell);
